import { blogCategoriesApi, blogPostsApi, sportsMasterDataApi } from "@/apis/apis";
import { AddIcon } from "@/constant/imagePath";
import { BASE_IMPORT_DATA } from "@/Modals/BlogManagement/BaseImport/baseImportData";
import { useNavigate } from "react-router-dom";
import BaseTable from "../BaseTable";
import { columns } from "./Columns";
import { FILTER_TYPE } from "@/constant/constants";
import { useGet } from "@/apiHooks/HttpFunctions";
import { LIST_MODE } from "@/constant/Lists/listMode";
import { STATUS } from "@/constant/statusConstants";

export default function BlogPostsPage() {
  const navigate = useNavigate();

  const { data: sportData } = useGet({
    apiURL: sportsMasterDataApi,
    params: {
      mode: LIST_MODE.ALL,
      status: STATUS.ACTIVE,
      sort: "order",
    }
  });
  const sportOptions = [
    { value: "", label: "All" },
    ...(sportData?.data?.map((item) => {
      return {
        value: item.code,
        label: item.code,
      }
    }) || []),
  ]

  const { data: categoryData } = useGet({
    apiURL: blogCategoriesApi,
    params: {
      mode: LIST_MODE.ALL,
      status: STATUS.ACTIVE,
      sort: "order",
    }
  });
  const categoryOptions = [
    { value: "", label: "All" },
    ...(categoryData?.data?.map((item) => {
      return {
        value: item.id.toString(),
        label: item.name,
      }
    }) || []),
  ]

  return (
    <BaseTable
      label="Post"
      apiURL={blogPostsApi}
      columns={columns()}
      importData={BASE_IMPORT_DATA.BLOG_POSTS}
      enableExport={true}
      enableSortData={true}
      enableAdd={false}
      customEditFn={({ id }) => navigate(`${id}/edit`)}
      additionalFilters={[
        {
          id: "filter[sport.code]",
          label: "Sport ID",
          type: FILTER_TYPE.SELECT,
          options: sportOptions,
        },
        {
          id: "filter[category.id]",
          label: "Category",
          type: FILTER_TYPE.SELECT,
          options: categoryOptions,
        },
      ]}
      statusColumn="default_status"
      confirmationModalTitleKey={(item) => item.default_title}
      customHeaderActionsData={[
        {
          label: "Add",
          onClick: () => navigate("create"),
          icon: () => <img src={AddIcon} className="h-4" alt="Add Post" />,
          backgroundColor: "golden-gradient",
        },
      ]}
    />
  );
}
